import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useStripe, useElements, Elements, CardElement } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';

import Input from '../input.component';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const WinRedStripeCreditCardInput = ({ onTokenGeneration, cardValidationError, setIsCardLoading, billingAddress }) => {
  const wrapperProps = { onTokenGeneration, cardValidationError, setIsCardLoading, billingAddress };
  return (
    <Elements stripe={stripePromise}>
      <Wrapper {...wrapperProps} />
    </Elements>
  );
};

WinRedStripeCreditCardInput.propTypes = {
  onTokenGeneration: PropTypes.func.isRequired,
  cardValidationError: PropTypes.bool.isRequired,
  billingAddress: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string,
  }),
};

const Wrapper = ({ onTokenGeneration, cardValidationError, setIsCardLoading, billingAddress }) => {
  const [stripeError, setStripeError] = useState(false);
  const [stripeMessage, setStripeMessage] = useState('Credit card is required');
  const [cardComplete, setCardComplete] = useState('');
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (cardValidationError) setStripeError(true);
  }, [cardValidationError]);

  const handleGetToken = async () => {
    const cardElement = elements.getElement(CardElement);

    try {
      setIsCardLoading(true);
      const tokenData = billingAddress ? {
        address_line1: billingAddress.line1,
        address_line2: billingAddress.line2,
        address_city: billingAddress.city,
        address_state: billingAddress.state,
        address_zip: billingAddress.postal_code,
        address_country: billingAddress.country || 'US',
      } : undefined;
      const results = await stripe.createToken(cardElement, tokenData);
      onTokenGeneration(results);
      setIsCardLoading(false);
    } catch (error) {
      setIsCardLoading(false);
      console.error(error);
    }
  };

  const handleOnChange = e => {
    const { complete, error } = e;
    setStripeError(!complete);
    setCardComplete(complete);
    setStripeMessage(error?.message);
    if (complete) handleGetToken();
  };

  return (
    <div autoComplete="new-password" className="winred-credit-card">
      <CardElement
        autocomplete="new-password"
        onChange={handleOnChange}
        options={{
          classes: { base: `react-stripe-card-element ${stripeError ? 'stripe-error' : ''}` },
          style: {
            base: {
              fontSize: '15px',
              color: '#1e2b3a',
              fontWeight: '500',
              '::placeholder': {
                color: stripeError ? '#dd4d5f' : '#1e2b3a',
                fontWeight: '500',
              },
            },
          },
        }}
      />
      <Input
        hidden
        value={cardComplete}
        name="stripe-card"
        onChange={() => {}}
        validators={['required']}
        errorMessages={[stripeMessage || 'Credit card is required']}
      />
    </div>
  );
};

Wrapper.propTypes = {
  onTokenGeneration: PropTypes.func.isRequired,
  cardValidationError: PropTypes.bool.isRequired,
  billingAddress: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string,
  }),
};

export default WinRedStripeCreditCardInput;
